module.exports = __webpack_public_path__ + "static/img/HK-Android.e717ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HK-Android.png
// module id = r3Fq
// module chunks = 1